import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationSales = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationSales',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9363F9",
    fillRule: "evenodd",
    d: "M32.453 96V68.263h6.6V96h-6.6ZM63.053 75.333v-7.07h-6.6v7.07h6.6ZM44.453 85.667V68.263h6.6v17.404h-6.6Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5DC04",
    fillRule: "evenodd",
    d: "m78.378 19.89-.474-4.212a5.196 5.196 0 0 0-4.582-4.582l-4.212-.474c-.147-.014-.147-.23 0-.244l4.212-.474a5.196 5.196 0 0 0 4.582-4.582l.474-4.212c.014-.147.23-.147.244 0l.474 4.212a5.196 5.196 0 0 0 4.582 4.582l4.212.474c.147.014.147.23 0 .244l-4.212.474a5.196 5.196 0 0 0-4.582 4.582l-.474 4.212c-.014.147-.223.147-.244 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4961FF",
    d: "m38.157 17.927-5.102-.057C33.364 12.69 37.37 4.27 47.078 4.27c10.97 0 14.261 8.941 14.261 13.686h-4.913c-.063-.864-1.13-8.62-9.194-8.64-7.664-.021-8.956 7.734-9.075 8.612Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#2E55C6",
    d: "M55.353 14.277a11.879 11.879 0 0 1 1.011 3.18v.02c.014.106.028.197.042.274v.028a.97.97 0 0 1 .021.176h4.913c0-1.355-.266-3.046-.905-4.78-.772 1.256-3.306 1.944-5.082 1.102ZM39.308 14.277c-1.909.28-4.351-.309-4.94-1.579-.801 1.804-1.222 3.636-1.313 5.173l5.102.056c.042-.302.225-1.425.758-2.765l.393-.885Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1305)",
    fillRule: "evenodd",
    d: "m69.51 17.284-43.768-.346c-2.21-.02-4.054 1.698-4.211 3.908-2.483 35.22-4.473 37.272-4.892 38.11-2.085 4.055 1.602 4.055 1.602 4.055h58.402c3.415 0 2.41-2.389 1.341-4.903-2.315-5.479-3.74-27.09-4.326-36.874a4.191 4.191 0 0 0-4.149-3.95Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#DB56E2",
    fillRule: "evenodd",
    d: "M18.241 63s54.987-.104 58.402 0c4.6.147 1.184-4.347.817-6.474-10.402 5.846-37.827 5.846-45.8-1.822-9.71-9.345-10.13-33.858-10.13-33.858-2.482 35.22-4.473 37.273-4.892 38.11C14.555 63 18.242 63 18.242 63Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E561E3",
    fillRule: "evenodd",
    d: "M35.001 29.478c-.24 0-.345.21-.43.44-2.817 7.584 1.206 15.284 10.152 16.237 11.01 1.184 14.152-7.081 16.017-16.237.052-.23-.189-.44-.43-.44h-3.582a.414.414 0 0 0-.409.398c-.21 2.996-5.604 5.364-8.653 5.364-3.048 0-7.867-2.368-8.076-5.364a.414.414 0 0 0-.409-.398h-4.18Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4961FF",
    fillRule: "evenodd",
    d: "M35.108 29.28c-.241 0-.44.188-.43.429.126 7.029 5.804 12.749 12.896 12.864 7.081.105 12.948-5.426 13.283-12.456a.419.419 0 0 0-.42-.44l-3.592-.052a.423.423 0 0 0-.42.398c-.25 2.996-5.688 5.28-8.736 5.228-3.048-.053-7.836-2.483-7.993-5.49a.423.423 0 0 0-.409-.408l-4.18-.074Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1305",
    x1: 43.181,
    x2: 63.963,
    y1: 60.495,
    y2: 3.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#F45FF6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.126,
    stopColor: "#F670F5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.724,
    stopColor: "#FCBAF0"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFD8EE"
  }))));
};
ColoredIllustrationSales.displayName = 'ColoredIllustrationSales';
export default withProvisionalOverrideFromContext(ColoredIllustrationSales);
//# sourceMappingURL=index.js.map